import type { ReactNode } from 'react';
import { ServicesNavContext } from '@/components/layout/services-nav-context';
import { useServicesNavTreeData } from './use-services-nav-tree';

/** Provides the services sidebar tree to the layout (see `services-nav-context.tsx`). */
export function ServicesNavProvider({ children }: { children: ReactNode }) {
  return <ServicesNavContext.Provider value={useServicesNavTreeData()}>{children}</ServicesNavContext.Provider>;
}
